import { Checkbox, CheckboxProps } from "@mui/material"

export const NexCheckbox = ({ ...props }: CheckboxProps) => {
    return <Checkbox sx={{ p: 0 }} {...props} />
}
